import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Slide15Traction() {
  const badges = ['Brands', 'Partners', 'Organizers'];
  const stats = ['5 brands ready for pilot', '10+ redeem partners', '6+ organizers', 'Mecenat channel → 2M users', 'MVP complete - SponsrAI structure running'];
  return <div className="flex flex-col h-full justify-center max-w-5xl mx-auto w-full" data-id="element-189">
      <motion.h2 className="text-5xl font-bold text-[#ffd700] mb-16 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} data-id="element-190">
        Traction
      </motion.h2>

      <div className="flex justify-center gap-8 mb-16" data-id="element-191">
        {badges.map((badge, i) => <motion.div key={i} initial={{
        scale: 0,
        rotate: -180
      }} animate={{
        scale: 1,
        rotate: 0
      }} transition={{
        delay: i * 0.2,
        type: 'spring'
      }} className="w-32 h-32 rounded-full bg-[#0a4d4d] border-4 border-[#4fd1c5] flex flex-col items-center justify-center shadow-lg shadow-[#4fd1c5]/20" data-id="element-192">
            <span className="text-white font-bold mb-1" data-id="element-193">{badge}</span>
            <CheckCircle2 className="w-8 h-8 text-[#ffd700]" data-id="element-194" />
          </motion.div>)}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-195">
        {stats.map((stat, i) => <motion.div key={i} initial={{
        x: -20,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} transition={{
        delay: 0.8 + i * 0.1
      }} className="flex items-center gap-4 p-4 rounded-lg bg-white/5 border border-white/10" data-id="element-196">
            <div className="w-2 h-2 rounded-full bg-[#ffd700]" data-id="element-197" />
            <span className="text-xl text-white" data-id="element-198">{stat}</span>
          </motion.div>)}
      </div>
    </div>;
}